export const TELUGU = {
  'language': 'Telugu',
  'amount': {
    'placeholder': 'మీరు ఎంత షెకరించాలని అనుకుంటున్నారు?',
    'error': {
      'min': 'కనీసం ₹2000 వేలు సేకరించాలి!',
      'max': '₹ 5 కోట్ల కంటే ఎక్కువ షెకరించలేరు ',
      'required': 'కనీసం ₹2000 వేలు సేకరించాలి!'
    },
    'hint': 'కనీసం ₹2000 వేలు సేకరించాలి',
    'popover': {
      'title': 'లక్ష్యం',
      // tslint:disable-next-line:max-line-length
      'desc': `మీరు మీ డబ్బుల లక్ష్యం తరువాత ఎప్పుడైనా మార్వచ్చు. ఎక్కడ ప్రారంభించాలో మీకు తెలియకపోతే, చాలా ప్రచారాలకి ₹ 1,00,000 ఏర్పాటు చెయ్యాలి అనే లక్ష్యం ఉంటుంది`,
      'eg': 'లక్ష్యం ₹ 2000 రూపాయాలకన్నా పెద్దదిగా ఉండాలి'
    }
  },
  'title': {
    'placeholder': 'ఫండ్రైసెర్ శీర్షిక',
    'error': {
      'minlength': 'ఫండ్రైసెర్ శీర్షిక 5-75 అక్షరాలా మధ్యలో ఉండాలి',
      'maxlength': 'ఫండ్రైసెర్ శీర్షిక 5-75 అక్షరాలా మధ్యలో ఉండాలి',
      'required': 'ఫండ్రైసెర్ శీర్షిక 5-75 అక్షరాలా మధ్యలో ఉండాలి'
    },
    'popover': {
      'title': 'ఇది మీ ఫండ్రైసెర్ శీర్షిక',
      'desc': 'ఉదాహరణ: నిరుపేద ఆడపిల్లలను శక్తివంతం చేయడంలో నాకు సహాయపడండి లేదా మా ఆస్తా క్యాన్సర్ పోరాడటానికి సహాయం చెయ్యండి!'
    },
  },
  'relation': {
    'placeholder': 'ఎవరికోసం డబ్బులు ఏర్పాటు చేస్తున్నారు?',
    'popover': {
      'title': 'ఎవరికోసం డబ్బులు ఏర్పాటు చేస్తున్నారు',
      'desc': 'ఉదాహరణ: మీరు వ్యక్తిగత, సృజనాత్మక, లేదా NGO కోసం ప్రచారం సృష్టించవచ్చు'
    },
    'error': {
      'required': 'దయచేసి చెల్లుబాటు అయినా ఎంపికను ఎంచుకోండి'
    }
  },
  'name': {
    'placeholder': `పేషెంట్ పూర్తి పేరు `,
    'error': {
      'maxlength': 'పేరు 50 అక్షరాలకన్నా ఎక్కువ ఉండకూడదు ',
      'pattern': 'దయచేసి సరైన పేరు పెట్టండి',
      'required': 'దయచేసి సరైన పేరు పెట్టండి'
    },
    'hint': 'పేషెంట్ ఆధార్ కార్డు మీద ఉన్న పేరు',
    'popover': {
      'title': `పేషెంట్ పేరు `,
      'desc': 'దయచేసి పేషెంట్ ఆధార్ కార్డు మీద ఉన్నటు పేరు రాయండి'
    }
  },
  'patient': {
    'placeholder': `పేషెంట్ పూర్తి పేరు`,
    'error': {
      'maxlength': 'పేరు 50 అక్షరాలకన్నా ఎక్కువ ఉండకూడదు ',
      'minlength': 'దయచేసి పేషెంట్ ఆధార్ కార్డు మీద ఉన్నటు తన పూర్తి పేరు రాయండి',
      'pattern': 'దయచేసి సరైన పేరు పెట్టండి',
      'required': 'దయచేసి సరైన పేరు పెట్టండి'
    },
    'hint': 'పేషెంట్ ఆధార్ కార్డు మీద ఉన్న పేరు',
    'popover': {
      'title': `పేషెంట్ పేరు `,
      'desc': 'దయచేసి పేషెంట్ ఆధార్ కార్డు మీద ఉన్నటు పేరు రాయండి'
    }
  },
  'age': {
    'placeholder': `పేషెంట్ వయసు`,
    'error': {
      'required': 'దయచేసిసరైన వయస్సు సమూహాన్ని రాయండి'
    }
  },
  'hosptialisationStatus': {
    'placeholder': `హాస్పిటలైజేషన్ స్థితి`,
    'error': {
      'required': 'సమాధానం అవసరం'
    }
  },
  'uploadImg': {
    'error': {
      'required': 'సమాధానం అవసరం',
      'pattern': 'దయచేసి చెల్లుబాటు అయ్యే నంబర్‌ను నమోదు చేయండి'
    }
  },
  'cause': {
    'placeholder': 'దయచేసి కారణాన్ని ఎంచుకోండి',
    'popover': {
      'title': 'ఇది మీ కారణం',
      'desc': 'ఇది మా వెబ్‌సైట్‌లో మీ డబ్బుల సేకరణని దయగల, ఒకటిగా ఆలోచించే వ్యక్తులకి కనుక్కోవడంలో సహాయం చేయడం కోసం.'
    },
    'error': {
      'required': 'దయచేసి కారణాన్ని ఎంచుకోండి'
    }
  },
  'survey': {
    'placeholder': 'మా గురించి మీరు ఎలా తెలుసుకున్నారు?',
    'error': {
      'required': 'సమాధానం అవసరం'
    }
  },
  'end_date': {
    'placeholder': 'ముగింపు తేది',
    'error': {
      'minlength': 'డబ్బుల సేకరణ ముగింపు తేదీ ఈరోజు కంటే పాతది కాకూడదు!',
    },
    'popover': {
      'title': 'డబ్బుల సేకరణ ముగింపు తేదీ ',
      'desc': 'మీ డబ్బుల సేకరణ ఈ రోజు ముగిస్తుంది '
    }
  },
  'fundraiser_image': {
    'placeholder': 'ఫండ్రైసెర్ ఫోటోని/వీడియోని ఇక్కడ అప్లోడ్ చెయ్యండి',
    'optional': '(ఉంటే)',
    'upload': 'అప్లోడ్',
    'popover': {
      'title': 'ఫండ్రైసెర్ ఫోటోని/వీడియోని అప్లోడ్ చెయ్యండి',
      'desc': `ఇది మీ ఫండ్రైజర్యోక్క యొక్క మొదటి పేజీ. మంచి ఫోటోలు మీకు ఎక్కువ డబ్బు సంపాదించడానికి సహాయపడతాయి. మీ ఫండ్రైజెర్ ఉత్తమంగా వివరించే దాపరికం ఫోటోలను/వీడియోలను అప్‌లోడ్ చేయండి.`,
      'eg': `ఆదర్శ పరిమాణం: 750x435 px. ఫోటో పెద్దది అయితే, చింతించకండి, అప్‌లోడ్ చేసేటప్పుడు మీరు దాన్ని చిన్నదిగా చేయవచ్చు.`
    }
  },
  'beneficiary_image': {
    'placeholder': `పేషెంట్ ఫోటోని పెట్టండి `,
    'popover': {
      'title': 'ఎవరికోసమైతే మీరు డబ్బులు సేకరిస్తున్నారో, వారే వీరు ',
      'desc': `"ఇమేజ్‌ని పెడితే విరాళాలు 50% పెరుగుతాయి.
          సేకరించిన నిధులు ఈ లబ్ధిదారుడికి వెళ్తాయని ధృవీకరించడానికి మేము మీ నించి అదనపు సమాచారాన్ని అభ్యర్థించవచ్చు."`
    }
  },
  'short_description': {
    'placeholder': 'లాఘువంగా వివరించండి',
    'error': {
      'minlength': 'కనీసం 10 అక్షరాలూ అవసరం',
      'maxlength': 'వివరణ 120 అక్షరాలను మించకూడదు'
    },
    'popover': {
      'title': 'లాఘువంగా వివరించండి',
      'desc': `లాఘువంగా 120 అక్షరాల్లో మీ ఫండ్రైజెర్ గురించి వివరించండి `,
      'eg': `ఉదాహరణ: ఆస్తాకు కేవలం 8 సంవత్సరాలు, తీవ్రమైన లింఫోబ్లాస్టిక్ లుకేమియాకు వ్యతిరేకంగా ఆమె పోరాటానికి సహాయం చెయ్యండి`
    }
  },
  'description_story': {
    'placeholder':
      'మీ అవసరానికి న్యాయం చేసేదేకాకుండా, చూసేవాళ్ళు సహాయం బటన్ని క్లిక్ చేసే కథను రాయండి'
      + '\n\nఈ దశలను అనుసరించండి:'
      + '\n* ఎవరికోసం డబ్బులు ఏర్పాటు చేస్తున్నారో వాళ్ళగురించి చెప్పండి, అది మీకోసమే ఐన లేకపోతే మీకీ ప్రియమైన వాళ్ళ కోసమైనా'
      + '\n* డబ్బులు ఎందుకు సేకరిస్తున్నారో వివరించండి'
      + '\n* మీ మద్దతుదారులకు విజ్ఞ్యాపించండి',
    'popover': {
      'title': 'మీ ఫండ్రైసెర్ గురించి మాకు ఇంకా చెప్పండి',
      'desc': 'మీ కథ చెప్పండి ',
      'placeholder':
        `<div>• మీ అవసరానికి న్యాయం చేసేదేకాకుండా, చూసేవాళ్ళు సహాయం బటన్ని క్లిక్ చేసే కథను రాయండి</div>
          <div>• మీరు మీ కథ రాసేటప్పుడు చిక్కుకుంటే, నిరాశ పడకండి.</div>
          <div>• కింద ఉన్న దశలను అనుసరించండి:</div>
          <div>• ఎవరికోసం డబ్బులు ఏర్పాటు చేస్తున్నారో వాళ్ళగురించి చెప్పండి, అది మీకోసమే ఐన లేకపోతే మీకు ప్రియమైన వాళ్ళ కోసమైనా </div>
          <div>• డబ్బులు ఎందుకు సేకరిస్తున్నారో వివరించండి</div>
          <div>• మీ మద్దతుదారులకు విజ్ఞ్యాపించండి</div>
          <div>• ఈ ఫండ్రైసర్ ఎందుకు మొదలుపెట్టారో మీ మద్దతుదారులకు చెప్పండి, తద్వారా వారు సహాయపడడానికి ఎక్కువ ఆతృతగా  వుంటారు.</div>
          <div>• మీ వివరాలన్నీ రాయండి, తద్వారా మీ మద్దతుదారులకి వారి డబ్బు ఎక్కడికి వెళ్తుందో తెలిసేందుకు</div>
          <div>• వర్డ్ డాక్యుమెంట్ నించి వివరాలు కాపీ పేస్ట్ చెయ్యకుండా చూసుకోండి.</div>`,
    }
  },
  'disease': {
    'label': 'వ్యాది పేరు ',
    'placeholder': 'మీ వ్యాధి పేరుని ఇక్కడ రాయండి',
    'error': {
      'required': 'దయచేసి ఒక వ్యాధిని ఎంచుకోండి'
    }
  },
  'hospital': {
    'label': 'ఆసుపత్రి',
    'placeholder': 'ఇక్కడ మీ ఆసుపత్రి పేరు రాయండి',
    'error': {
      'required': 'దయచేసి ఒక ఆసుపత్రిని ఎంచుకోండి'
    }
  },
  'ngo': {
    'placeholder': 'ఎన్జీఓ పేరు',
    'error': {
      'notFound': 'ఈ పేరుతో ఏ ఎన్జీఓ కనుగొనబడలేదు'
    },
    'popover': {
      'title': 'ఎన్జీఓ',
      'desc': 'ఎన్జీఓ'
    }
  },
  'city': {
    'placeholder': 'మీ నగరం పేరు రాయండి',
    'popover': {
      'title': 'మీ ఫండ్రైజెర్ నగరం పేరు రాయండి',
      'desc': 'ఈ ఫండ్రైజెర్ నడుస్తున్న నగరం ఇది.'
    }
  },
  'beneficiaryname': {
    'placeholder': 'లబ్దిదారుని పేరు',
    'error': {
      'maxlength': 'లబ్ధిదారులు 50 అక్షరాలకకి మించకూడదు',
      'pattern': 'దయచేసి సరైన పేరు పెట్టండి ',
      'required': 'దయచేసి లబ్ధిదారుని ఎంచుకోండి'
    },
    'popover': {
      'title': 'ఎవరికైతే డబ్బు ఏర్పాటు చేస్తున్నారు, వాళ్ల పేరు',
      'desc': 'మీ మద్దతుదారులకి ఎవరికోసం డబ్బులు ఏర్పాటు చేస్తున్నారో చెప్పడం అవసరం. '
    }
  },
  'names': {
    'placeholder': 'పేరు',
    'hint': 'పేషెంట్ ఆధార్ కార్డు మీద ఉన్న పేరు',
    'error': {
      'maxlength': 'గరిష్ట అక్షర పరిమితి మించిపోయింది',
      'pattern': 'దయచేసి సరైన పేరు పెట్టండి '
    },
  },
  'email': {
    'placeholder': 'ఈమెయిల్',
    'error': {
      'email': 'దయచేసి సరైన ఈమెయిల్ రాయండి',
    },
  },
  'password': {
    'placeholder': 'పాస్‌వర్డ్‌ని సృష్టించండి',
    'error': {
      'minlength': 'దయచేసి కనీసం 8 అక్షరాలని రాయండి',
      'pattern': 'కనీసం 1 సంఖ్య, 1 పెద్ద అక్షరం మరియు 1 చిన్న అక్షరం అవసరం'
    }
  },
  'mobile': {
    'placeholder': 'మొబైల్',
  },
  'reward_title': {
    'placeholder': 'బహుమతి శీర్షిక',
    'error': {
      'minlength': 'కనీసం 5 అక్షరాలు అవసరం',
      'maxlength': 'బహుమతి శీర్షిక 50 అక్షరాలని మించకూడదు'
    },
    'popover': {
      'title': 'బహుమతి శీర్షికను రాయండి',
      'desc': 'బహుమతికి ఆకర్షణీయమైన శీర్షిక పెట్టండి '
    }
  },
  'guardian_relations': {
    'Friend': {
      'Below 5 years': 'గార్డియన్  నెంబర్ అవసరం',
      '6 -10 years': 'గార్డియన్  నెంబర్ అవసరం',
      '11 - 17 years': 'గార్డియన్  నెంబర్ అవసరం',
      '18 - 30 years': 'పేషెంట్ నెంబర్ అవసరం',
      '30 - 40 years': 'పేషెంట్ నెంబర్ అవసరం',
      'Above 40 years': 'పేషెంట్ నెంబర్ అవసరం'
    },
    'Friend\'s Family': {
      'Below 5 years': 'గార్డియన్  నెంబర్ అవసరం',
      '6 -10 years': 'గార్డియన్  నెంబర్ అవసరం',
      '11 - 17 years': 'గార్డియన్  నెంబర్ అవసరం',
      '18 - 30 years': 'పేషెంట్ నెంబర్ అవసరం',
      '30 - 40 years': 'పేషెంట్ నెంబర్ అవసరం',
      'Above 40 years': 'పేషెంట్ నెంబర్ అవసరం'
    },
    'Colleague': {
      'Below 5 years': 'గార్డియన్  నెంబర్ అవసరం',
      '6 -10 years': 'గార్డియన్  నెంబర్ అవసరం',
      '11 - 17 years': 'గార్డియన్  నెంబర్ అవసరం',
      '18 - 30 years': 'పేషెంట్ నెంబర్ అవసరం',
      '30 - 40 years': 'పేషెంట్ నెంబర్ అవసరం',
      'Above 40 years': 'పేషెంట్ నెంబర్ అవసరం'
    },
    'Relative': {
      'Below 5 years': 'గార్డియన్  నెంబర్ అవసరం',
      '6 -10 years': 'గార్డియన్  నెంబర్ అవసరం',
      '11 - 17 years': 'గార్డియన్  నెంబర్ అవసరం',
      '18 - 30 years': 'పేషెంట్ నెంబర్ అవసరం',
      '30 - 40 years': 'పేషెంట్ నెంబర్ అవసరం',
      'Above 40 years': 'పేషెంట్ నెంబర్ అవసరం'
    },
    'Legal ward': {
      '18 - 30 years': 'పేషెంట్ నెంబర్ అవసరం',
      '30 - 40 years': 'పేషెంట్ నెంబర్ అవసరం',
      'Above 40 years': 'పేషెంట్ నెంబర్ అవసరం'
    }
  },
  'otp': {
    'placeholder': `ఓటీపీ`,
    'error': {
      'required': 'దయచేసి ఓటీపీ ని ఇక్కడ రాయండి'
    }
  },
  get_otp: 'OTP ను మళ్ళీ పంపు',
  verify_mobile: 'మొబైల్ నంబర్‌ని ధృవీకరించండి',
  start_your_fundraiser: 'మీ ఫండ్రైజెర్ ప్రారంభించండి',
  change_easily: 'మీరు ఎప్పుడైనా మీ ఫండ్రైస్ర్కీ  సులభంగా మార్పులు చేయవచ్చు',
  tell_us_more: 'మీ ఫండ్రైసెర్ గురించి మాకు ఇంకా చెప్పండి',
  tellAboutFundraiser: 'మీ ఫండ్రైసెర్ గురించి మాకు ఇంకా చెప్పండి',
  patientIsMy: 'పేషెంట్ నా... ',
  raising_funds_for: 'డబ్బులు సేకరణ చేసే కారణం',
  ngo_charity: 'ఎన్జీఓ/దాతృత్వం',
  qualification: 'మీ విద్యా అర్హత',
  occupation: 'మీ ఉద్యోగ స్థితి',
  purposeText: 'ప్రయోజనం',
  other: 'ఇతర',
  iAgree: 'నేను కెట్టోకి అంగీకరిస్తున్నాను',
  serviceAgreement: 'సేవ ఒప్పందం',
  and: 'మరియు',
  change_purpose: 'కారణం మార్చాలా',
  save_and_continue: 'సేవ్ చేసి కొనసాగించండి',
  ketto_zero_fee: 'కెట్టొ  యొక్క జీరో ప్లాట్ఫార్మ్ ఫీజు పాలసీ మీకు ఎక్కువ డబ్బులు దక్కేటట్టు చూస్తుంది ',
  is_patient_admitted: 'పేషెంటుని ఆస్పత్రిలో చేర్పించారా?',
  tell_us_about_patient: `పేషెంట్ గురించి చెప్పండి`,
  medical_condition: `వ్యాది పేరు `,
  guardian_no: `గార్డియన్ మొబైల్ నంబర్`,
  patient_no: 'పేషెంట్ మొబైల్ నంబర్',
  yes: `అవును `,
  no: `లేదు`,
  optional: '(ఉంటే)',
  story_form_title: `మీరు డబ్బులు ఎందుకు సేకరిస్తున్నారో చెప్పండి`,
  help_me_write_this: `ఇది రాయడానికి నాకు సహాయం చెయ్యండి`,
  terms_of_use: `ఉపయోగ నిబంధనలు`,
  privacy_policy: `గోప్యతా పాలసీలు`,
  plans_and_pricing: `ప్రణాళికలు & ధరలను`,
  choose_file: 'ఫైల్‌ని ఎంచుకోండి',
  submit_for_approval: 'ఆమోదం కోసం సమర్పించండి',
  exisiting_account: 'అకౌంట్ వుందా?',
  login: 'ఇక్కడ లాగిన్ అవ్వండి',
  next: 'తరువాత',
  purpose: 'డబ్బుల సేకరణ కారణం',
  are_you_an_ngo: 'మీరు ఒక ఎన్జీఓ నా?',
  apply_here: 'ఇక్కడ వర్తించండి',
  get_assistance: 'సహాయం పొందండి',
  validPhNo: 'దయచేసి చెల్లుబాటు అయ్యే నంబర్‌ను నమోదు చేయండి ',
  back: 'వెనకాలకి',
  fieldRequired: 'సమాధానం అవసరం',
  acknowledge: 'పైన ఇచ్చిన సమాచారం నా జ్ఞానం మరియు నమ్మకానికి సరైనదని నేను గుర్తించాను మరియు ధృవీకరిస్తున్నాను. తప్పు అని తేలితే నేను బాధ్యత వహించాలని అంగీకరిస్తున్నాను. రెగ్యులేటరీ అధికారులతో భాగస్వామ్యం చేయడానికి లేదా చట్టం ప్రకారం అవసరమయ్యే విధంగా బహిర్గతం చేయడానికి నేను దీని ద్వారా నా సమ్మతిని ఇస్తున్నాను.',
};
